// extracted by mini-css-extract-plugin
export default {"transactionsTable":"TransactionsTable_transactionsTable__stMzk"};